import { useQuery } from '@tanstack/react-query';
import { operations } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type ListRemittanceEnvelopesResponse =
  operations['listRemittanceEnvelopes']['responses'][200]['content']['application/json'];

export type RemittanceEnvelope = ListRemittanceEnvelopesResponse['data'][number];

export const REMITTANCE_ENVELOPES_QUERY_KEY = ['remittance-envelopes'];

// The endpoint 404s ("No supplier integration company found for the requesting user") rather than
// returning an empty list when the caller has no linked company yet — pass `enabled: false` until
// one exists (e.g. before Instant Pay onboarding step 1 completes) so this doesn't throw to the
// nearest error boundary (the global QueryClient default is `throwOnError: true`).
const useRemittanceEnvelopes = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: REMITTANCE_ENVELOPES_QUERY_KEY,
    queryFn: () =>
      apiClient.get('api/supplier-experience/remittance-envelopes').json<ListRemittanceEnvelopesResponse>(),
    select: (response) => new Map(response.data.map((envelope) => [envelope.makerOrganizationUuid, envelope])),
    enabled,
  });
};

export default useRemittanceEnvelopes;
